export default {"src":"/_next/static/media/location-pin.f6f21c77.svg","height":379,"width":379};